/**
 * The one progress bar the projects tab draws, in the list and on the page.
 *
 * A file of its own rather than a private helper in either, because both draw it
 * and the second copy is the one that drifts: a client comparing the row they
 * clicked with the page it opened must not see two different bars for the same
 * percentage.
 */
export function ProgressBar({ pct }: { pct: number }) {
  return (
    <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
      {/* Clamped here rather than trusted: `progressPct` is computed from task
          counts on the CRM side, and a bar wider than its track paints over the
          layout beside it. */}
      <div
        className="h-full rounded-full bg-primary transition-all"
        style={{ width: `${Math.min(100, Math.max(0, pct))}%` }}
      />
    </div>
  );
}
